import React from 'react';
import { Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import 'PointOfSale/styles/components/setSiteAndDate.less';

const SetDateSiteHeader = ({ currentSelectedSession, onClose }) => (
  <div className="headerHeight">
    <div className="inlineBlockWithFloatLeft">
      <div className="inlineBlockWithFloatLeft">
        <Icon className="site-icon" name="pencil" size="large" />
      </div>
      <div className="displayInlineBlock">
        <span className="primaryLabel">Edit</span>
        <br />
        <span className="secondaryLabel">Date & Site</span>
      </div>
    </div>
    <div className="sessionLabel">
      <span className="secondaryLabel">{currentSelectedSession}</span>
    </div>
    <div className="closeIconCss cursorPointer" onClick={onClose}>
      <Icon name="close" />
    </div>
  </div>
);

SetDateSiteHeader.propTypes = {
  currentSelectedSession: PropTypes.string,
};

export default SetDateSiteHeader;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/setDateAndSite/component/SetDateSiteHeader.js